import Main from "./components/Main";
import React from 'react';
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  return (
    <HelmetProvider>
      <Main />
    </HelmetProvider>
  );
};
export default App;
